import CommonIcon from '_c/common-icon'
import { showTitle } from '@/library/utils'
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle (item) {
      return showTitle(item, this)
    },
    showChildren (item) {
      return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways))
    },
    getNameOrHref (item, children0) {
      if(typeof item.children[0].children !== 'undefined') {
        let data = item.children[0].children
        for(let k in data){
          return data[k].name
        }
      }else{
        return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
      }
    },
    getNameOrActive (item, children0) {
       return item.name
    }
  }
}
